define(
({
  "load_error": "Läsningsfel",
  "description": "Förfrågan slutfördes inte korrekt. Du bör se till att din beställning sparats och sedan uppdatera den här sidan."
})
);
